
const BASE_URL = process.env.NODE_ENV_URL;
export const splunkApi1 = `${BASE_URL}/siem/getSplunkAPI`;
export const getConfluentAPI = `${BASE_URL}/siem/getConfluentAPI`;
export const streamKafkaLogs = `${BASE_URL}/siem/streamKafkaLogs`;
export const streamElasticRawLogs = `${BASE_URL}/siem/streamElasticRawLogs`;
export const streamElasticFilterLogs = `${BASE_URL}/siem/streamElasticFilterLogs`;
export const splunkRawLogsStream = `${BASE_URL}/siem/splunkRawLogsStream`;
export const splunkFilteredLogsStream = `${BASE_URL}/siem/splunkFilteredLogsStream`;
export const elasticLogValues = `${BASE_URL}/siem/elasticLogValues`;
export const streamElasticAILogs = `${BASE_URL}/siem/streamElasticAILogs`;
export const contactUsAPI = `${BASE_URL}/submitForm`;